import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store';
import { App } from './App';
import { LocalizationProvider } from '@roi-pros/react';
import './index.css';
// Platform Experience design tokens (CSS custom properties) — required so adopted
// px-react components resolve their `--lu-*` variables. B4 adoption: presentation only.
import '@roi-pros/px-tokens/tokens.css';

// L6 bootstrap: profile is null at the admin-app root — admin does not
// consume /api/suite/switch-context. The provider resolves to platform
// defaults (en / en-US / US / UTC / USD). Suite-app frontends should
// pass response.localization from switch-context here when they adopt
// this module.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <LocalizationProvider profile={null}>
        <App />
      </LocalizationProvider>
    </Provider>
  </React.StrictMode>
);
